/** Trim and prepend https:// when the user enters a bare domain (browser-bar style). */
export function normalizeWebsiteUrl(raw: string | undefined | null): string {
  const trimmed = (raw ?? '').trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (trimmed.startsWith('//')) return `https:${trimmed}`
  return `https://${trimmed.replace(/^\/+/, '')}`
}

/** Returns a validation message or null when empty/valid. */
export function validateWebsiteUrl(raw: string | undefined | null): string | null {
  const normalized = normalizeWebsiteUrl(raw)
  if (!normalized) return null
  try {
    const url = new URL(normalized)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      return 'Website must be a valid URL'
    }
    return null
  } catch {
    return 'Website must be a valid URL'
  }
}

/** Normalize and validate website for save; returns `{ website, error }`. */
export function prepareWebsiteForSave(raw: string | undefined | null): {
  website: string
  error: string | null
} {
  const website = normalizeWebsiteUrl(raw)
  return { website, error: validateWebsiteUrl(website) }
}
